// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#fff","subMenuActiveText":"#fff","menuBg":"#004CA7","menuHover":"#1B9CD5","subMenuBg":"#0046AD","subMenuHover":"#006cc1","sideBarWidth":"180px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/style.scss
// module id = qK5K
// module chunks = 24